export function HrFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/hr-filled.svg'"></ng-include>`
    }
}